module.exports = __webpack_public_path__ + "img/voc.08f951ff.png";